import React, {Component} from 'react';

import '../../Frontpage.css';

import '../../common_styles/table.css'
import {getSamplesByUser} from "../../operations/fetch";
import FigureCalculator from "../../FigureCalculator";
import MapWrapper from "./MapWrapper";
import {Button} from "jjfw";
import Utility from "../../Utility";
import CsvExporter from "../../CsvExporter";
import {Link} from "@reach/router";

const FC = FigureCalculator;

export default class Measurements extends Component {

    constructor(props) {
        super(props);

        this.state = {
            accessToken: this.props.accessToken,
            selectedSamples: [],
            summary: false,
            show_company: false,
            coordinates: {lat: null, lng: null},
            page: 0,
            samples: []
        };

        this.getMeasurements();
    }

    async getMeasurements() {

        let arr = this.state.samples.concat(this.setIsSampleOnAllTrees(await getSamplesByUser(
                this.state.accessToken, this.state.page)))

        this.setState({samples: arr, page: this.state.page + 1});
    }

    setIsSampleOnAllTrees(samples) {
        return samples.map(
            s => {
                s.trees[0] = s.trees[0].map(t => {
                    t.isSample = s.measure_method_type !== 2
                    return t
                })
                return s
            }
        )
    }

    render() {
        return (
            <div>
                <div style={{float: "left", padding: 10, margin: 25, backgroundColor: "white", border: "1px solid lightgrey", display: "inline-block", width: 854}}>
                    <div style={{width: "100%", height: 40, borderBottom: "1px solid black", fontSize: 20}}>Samples</div>
                    <header>
                        <div style={{float: "right", margin: 10}}>
                            <Button text="Export Raw Data CSV" function={()=>
                                CsvExporter.export(this.getRawData())
                            }/>
                        </div>
                        <div style={{float: "right", margin: 10}}>
                            <Button text="Export Sample CSV" function={()=>
                                CsvExporter.export(this.getCSVRows())
                            }/>
                        </div>
                        <div style={{height: window.innerHeight - 50, float: "left", margin: 20, marginTop: 20}}>
                            <br/>
                            <table className="ar-table">
                                <thead>
                                <tr>
                                    <th>Select</th>
                                    {this.state.show_company ? <th>Email</th> : null}
                                    <th>Date</th>
                                    <th>radius/length</th>
                                    <th>Trees per Hectare</th>
                                    <th>Diameter (QMD - cm)</th>
                                    <th>Height (Lorey´s m)</th>
                                    <th>Basal Area - m2</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.renderSamples()}
                                </tbody>
                                <tfoot>
                                {this.renderSum()}
                                </tfoot>
                            </table>
                            <br />
                            <Button text="Load more samples" function={()=>
                                this.getMeasurements()
                            }/>
                            {this.state.selectedSamples.length === 0 ?
                                null
                                :
                                <Link to="./summary" state={{samples: this.state.samples.filter((sample)=> this.state.selectedSamples.includes(sample.id)) }}>
                                    <Button text="Render Summary"/></Link>
                            }
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                        </div>
                    </header>
                </div>
                <div style={{float: 'left', padding: 10, margin: 25, backgroundColor: "white", border: "1px solid lightgrey", display: "inline-block", height: (window.innerHeight - 220),
                    width: window.innerWidth - 1035,
                    position: "fixed"
                }}>
                        <div style={{width: "100%", height: 40, borderBottom: "1px solid black", fontSize: 20}}>Map</div>
                    <div style={{position: "fixed", top: 175, border: "1px black solid"}}>
                        <MapWrapper samples={this.state.samples} summary={false} coordinates={this.state.coordinates}/>
                    </div>
                </div>
            </div>
        );
    }

    renderSum(){
        if (this.state.selectedSamples.length === 0){
            return (
                <tr>
                    <td style={{FontWeight: "bold"}}>Sum: </td>
                    {this.state.show_company ? <td>-</td> : null}
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
            )
        } else {

            let selected = this.state.samples.filter((sample)=> this.state.selectedSamples.includes(sample.id));

            let allTrees = selected.reduce((a,b)=>a.concat(b.trees[0]),[]);
            let radii = selected.reduce((a, b)=> a.concat([b.sample_radius]),[]);

            return (
                <tr>
                    <td style={{FontWeight: "bold"}}>Sum: </td>
                    {this.state.show_company ? <td>-</td> : null}
                    <td>-</td>
                    <td>-</td>
                    <td>{(allTrees.length / FC.radiiToHectare(radii)).toFixed(1)}</td>
                    <td>{FC.dgv(allTrees.map(x => x.diameter)).toFixed(1)}</td>
                    <td>{FC.mean(allTrees.map(x => x.height)).toFixed(1)}</td>
                    <td>{FC.base_area(allTrees, FC.areaToHectare(FC.getAreaFromSamples(selected))).toFixed(1)}</td>
                </tr>
            )
        }
    }

    renderSamples() {

        if (this.state.samples === undefined) {
            return null
        }

        if (this.state.samples.length === 0) {
            return (<tr>
                <td>You have no measurements, download the app !</td>
            </tr>)
        }

        return (this.state.samples.map((sample) =>
            <tr key={sample.id}>
                <td><input type="checkbox" checked={this.state.selectedSamples.includes(sample.id)}
                           onChange={() => {
                                if(this.state.selectedSamples.includes(sample.id)){
                                    this.setState({
                                        selectedSamples: this.state.selectedSamples.filter((i)=> i !== sample.id)
                                    })
                                }
                                else {
                                    let arr = this.state.selectedSamples;
                                    arr.push(sample.id);
                                    this.setState({
                                        selectedSamples: arr,
                                        coordinates: {lat: sample.latitude, lng: sample.longitude}
                                    })
                           }
                }}/></td>
                {this.state.show_company ? <td>{sample.email}</td> : null}
                <td>{Utility.unixToDateTime(sample.unix_time)}</td>
                <td>{sample.sample_radius ? sample.sample_radius.toFixed(2) : sample.belt_max_distance.toFixed(2)}</td>
                <td>{FC.trunksPerHectare(sample).toFixed(1)}</td>
                <td>{FC.dgv(sample.trees[0].map(x => x.diameter)).toFixed(1)}</td>
                <td>{FC.mean(sample.trees[0].map(x => x.height)).toFixed(1)}</td>
                <td>{FC.base_area(sample.trees[0], FC.areaToHectare(FC.getAreaFromSamples([sample]))).toFixed(1)}</td>
            </tr>
        ))
    }

    getCSVRows() {
        console.log(this.state.samples)
        let rows = [];
        let header = [];
        header.push("Date");
        header.push("Radius/Length");
        header.push("Trunks per hectare");
        header.push("DGV");
        header.push("Avg. height");
        header.push("Basal area");
        header.push("Latitude");
        header.push("Longitude");
        header.push("Sample ID");
        header.push("Comment")
        header.push("Sample Name")
        rows.push(header);
        this.state.samples.forEach((sample) => {
            let row = [];
            row.push(Utility.unixToDateTime(sample.unix_time));
            row.push(sample.sample_radius ? sample.sample_radius.toFixed(2) : sample.belt_max_distance.toFixed(2));
            row.push(FigureCalculator.trunksPerHectare(sample).toFixed(1));
            row.push(FigureCalculator.dgv(sample.trees[0].map(x => x.diameter)).toFixed(1));
            row.push(FigureCalculator.mean(sample.trees[0].map(x => x.height)).toFixed(1));
            row.push(FC.base_area(sample.trees[0], FC.areaToHectare(FC.getAreaFromSamples([sample]))).toFixed(1))
            row.push(sample.latitude);
            row.push(sample.longitude);
            row.push(sample.id);
            row.push(sample.comment);
            row.push(sample.external_name)
            rows.push(row);
        });
        return rows;
    }

    getRawData() {
        let allTrees = this.state.samples.reduce((a,b)=>a.concat(b.trees[0]),[]);

        let rows = [];
        let header = [];
        header.push("Date")
        header.push("Latitude")
        header.push("Longitude")
        header.push("Diameter");
        header.push("Name");
        header.push("Latin Name");
        header.push("Sample id");
        header.push("Avg. height for specie in sample");
        rows.push(header);
        allTrees.forEach((tree) => {
            let row = [];
            row.push(Utility.unixToDateTime(tree.unix_time));
            row.push(tree.gps_latitude)
            row.push(tree.gps_longitude)
            row.push(tree.diameter);
            row.push(tree.english_name);
            row.push(tree.latin_name)
            row.push(tree.sample_id);
            row.push(tree.height);
            rows.push(row);
        });
        return rows;
    }

}
